import React, { Suspense, lazy } from 'react';
import { StickyAlertBar } from '../components/StickyAlertBar';
import { HeroSection } from '../components/HeroSection';
/* Below-fold sections loaded lazily — reduces initial JS parse time */
const SalesLetter = lazy(() => import('../components/SalesLetter').then(m => ({
  default: m.SalesLetter
})));
const WhatYouGet = lazy(() => import('../components/WhatYouGet').then(m => ({
  default: m.WhatYouGet
})));
const BonusStack = lazy(() => import('../components/BonusStack').then(m => ({
  default: m.BonusStack
})));
const DynamicPricing = lazy(() => import('../components/DynamicPricing').then(m => ({
  default: m.DynamicPricing
})));
const SocialProofFooter = lazy(() => import('../components/SocialProofFooter').then(m => ({
  default: m.SocialProofFooter
})));
export function LandingPage() {
  return <div className="w-full min-h-screen" style={{
    background: 'var(--bg-page)',
    fontFamily: 'var(--font-body)'
  }} data-id="element-440">
      {/* A. Sticky Alert Bar — above fold, eager */}
      <StickyAlertBar data-id="element-441" />

      {/* B. Hero Section — above fold, eager */}
      <HeroSection data-id="element-442" />

      {/* C–G. Below-fold sections — lazy loaded */}
      <Suspense fallback={null} data-id="element-443">
        <div className="section-lazy" data-id="element-444">
          <SalesLetter data-id="element-445" />
        </div>
        <div className="section-lazy" data-id="element-446">
          <WhatYouGet data-id="element-447" />
        </div>
        <div className="section-lazy" data-id="element-448">
          <BonusStack data-id="element-449" />
        </div>
        <div className="section-lazy" data-id="element-450">
          <DynamicPricing data-id="element-451" />
        </div>
        <div className="section-lazy" data-id="element-452">
          <SocialProofFooter data-id="element-453" />
        </div>
      </Suspense>
    </div>;
}